import { all, call, takeEvery, put, delay } from "redux-saga/effects";
import customerActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";

const customerSagas = function* () {
  yield all([
    yield takeEvery(customerActions.GET_REPORTS, getReports),
    yield takeEvery(customerActions.GET_PAYMENT_HISTORY, getPaymentHistory),
    yield takeEvery(
      customerActions.GET_APPLICATION_STATUS,
      getApplicationStatus
    ),
    yield takeEvery(customerActions.GET_SEARCH_CANDIDATE, getSearchCandidate),
    yield takeEvery(customerActions.GET_GENERATE_REPORT, getGenerateReport),
    yield takeEvery(customerActions.GET_DATEWISE_REPORT, getDatewiseReport),
    yield takeEvery(
      customerActions.GET_CONSOLIDATE_REPORT,
      getConsolidateReport
    ),
    yield takeEvery(
      customerActions.GET_GENDERCATEGEORY_REPORT,
      getGenderCategeoryReport
    ),
    yield takeEvery(
      customerActions.GET_OBJECTIONTRACK_REPORT,
      getObjectionTrackReport
    ),
    yield takeEvery(
      customerActions.GET_OBJECTION_PAYMENT_REPORT,
      getObjectionPaymentReport
    ),
    yield takeEvery(
      customerActions.GET_UNIQUE_OBJECTION_REPORT,
      getUniqueObjectionReport
    ),
    yield takeEvery(
      customerActions.GET_NOOFATTEMPTS_REPORT,
      getNoOfAttemptsReport
    ),
    yield takeEvery(
      customerActions.GET_PREFERENCEWISE_REPORT,
      getPreferenceWiseReport
    ),
    yield takeEvery(
      customerActions.GET_VBSA_REPORT,
      getVBSAReport
    ),
    yield takeEvery(
      customerActions.GET_ALL_COURSES_PREFERENCEWISE_REPORT,
      getAllCoursesPreferenceWiseReport
    ),
    yield takeEvery(
      customerActions.UPLOAD_RECONCILIATION_FILE,
      uploadReconciliationFile
    ),
    yield takeEvery(
      customerActions.GET_RECONCILIATION_REPORT,
      getReconciliationReport
    ),
    yield takeEvery(customerActions.GET_LATEST_DB_DUMP, getLatestDbDump),
    yield takeEvery(
      customerActions.GET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES,
      getPreferenceWiseReportForAllCourses
    ),
    yield takeEvery(
      customerActions.OVERRIDE_RECONCILIATION_STATUS,
      overrideReconciliationStatus
    ),
    yield takeEvery(
      customerActions.DOWNLOAD_RECONCILIATION_REPORT,
      downloadReconciliationReport
    ),
  ]);
};

const getReports = function* (data) {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  const { payload } = data;

  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/reports/${payload?.courseid}`)
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_REPORTS,
        payload: result?.data?.data,
      });
    } else {
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getPaymentHistory = function* (data) {
  const { courseid, emailid, mobileno, applicantionid } = data.payload;
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/payment-history`, {
        params: {
          courseid: courseid,
          emailid: emailid,
          mobileno: mobileno,
          applicantionid: applicantionid,
        },
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_PAYMENT_HISTORY,
        payload: result?.data?.result,
      });
    } else {
      yield put({
        type: customerActions.SET_PAYMENT_HISTORY,
        payload: [],
      });
    }
  } catch (err) {}
};

const getApplicationStatus = function* (data) {
  const { courseid, emailid, mobileno, applicantionid, dob, candidatename } =
    data.payload;
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/application-status`, {
        params: {
          courseid: courseid,
          emailid: emailid,
          mobileno: mobileno,
          applicantionid: applicantionid,
          dob: dob,
          candidatename: candidatename,
        },
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_APPLICATION_STATUS,
        payload: result?.data?.result,
      });
    } else {
      yield put({
        type: customerActions.SET_APPLICATION_STATUS,
        payload: [],
      });
    }
  } catch (err) {}
};

const getSearchCandidate = function* (data) {
  const { courseid, emailid, mobileno, applicantionid, dob, candidatename } =
    data.payload;
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/search-candiate`, {
        params: {
          courseid: courseid,
          emailid: emailid,
          mobileno: mobileno,
          applicantionid: applicantionid,
          dob: dob,
          candidatename: candidatename,
        },
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_SEARCH_CANDIDATE,
        payload: result?.data?.result,
      });
      // localStorage.setItem("totalData",JSON.stringify(result?.data?.result))
    } else {
      yield put({
        type: customerActions.SET_SEARCH_CANDIDATE,
        payload: [],
      });
    }
  } catch (err) {}
};

const getGenerateReport = function* (data) {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  const { payload } = data;

  try {
    // const result = yield call(() =>
    //   axios.get(
    //     `${API_URL}/backoffice/customer/generate-report/${payload?.courseid}`
    //   )
    // );
    // if (result?.data?.statusCode === 200) {
    //   yield put({
    //     type: customerActions.SET_GENERATE_REPORT,
    //     payload: result?.data?.data,
    //   });
    // }
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getDatewiseReport = function* (data) {
  const { courseid } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/datewise-reg-report`, {
        params: {
          courseids: courseid,
        },
      })
    );

    if (result?.data?.statusCode === 200) {
      const dateWiseReportData = result.data.result;

      yield put({
        type: customerActions.SET_DATEWISE_REPORT,
        payload: dateWiseReportData,
      });
    }
  } catch (err) {
    console.error(err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getConsolidateReport = function* (data) {
  const { isdownload } = data?.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    if (parseInt(isdownload) == 1) {
      let response = yield call(() =>
        axios.get(
          `${API_URL}/backoffice/customer/consolidate-report?isdownload=1`,
          {
            responseType: "blob", // IMPORTANT
          }
        )
      );
      const csvText = yield call(() => response.data.text()); // ⬅️ IMPORTANT (not blob)
      const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `consolidated-report-${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/consolidate-report`)
    );

    if (result?.data?.statusCode === 200) {
      const consolidateReportData = result.data.result;

      yield put({
        type: customerActions.SET_CONSOLIDATE_REPORT,
        payload: consolidateReportData,
      });
    }
  } catch (err) {
    console.error("Error fetching consolidate report:", err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getNoOfAttemptsReport = function* () {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/no-of-attempts-report`)
    );

    if (result?.data?.statusCode === 200) {
      const noOfAttemptsReportData = result.data.result;

      yield put({
        type: customerActions.SET_NOOFATTEMPTS_REPORT,
        payload: noOfAttemptsReportData,
      });
    }
  } catch (err) {
    console.error("Error fetching no of attempts report:", err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getGenderCategeoryReport = function* () {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/gender-categeory-report`)
    );

    if (result?.data?.statusCode === 200) {
      const genderCategoryData =
        result.data.result[0]?.rpt_gendercategoryreport;

      yield put({
        type: customerActions.SET_GENDERCATEGEORY_REPORT,
        payload: genderCategoryData,
      });
    }
  } catch (err) {
    console.error(err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getObjectionTrackReport = function* (data) {
  const { courseid, rollno } = data.payload;
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/objection-track-report`, {
        params: {
          courseid: courseid,
          rollno: rollno,
        },
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_OBJECTIONTRACK_REPORT,
        payload: result?.data?.result,
      });
    } else {
      yield put({
        type: customerActions.SET_OBJECTIONTRACK_REPORT,
        payload: [],
      });
    }
  } catch (err) {}
};

const getObjectionPaymentReport = function* (data) {
  const { courseid, rollno } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/objection-payment-report`, {
        params: {
          courseid: courseid,
          rollno: rollno,
        },
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_OBJECTION_PAYMENT_REPORT,
        payload: result?.data?.result,
      });

      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    } else {
      yield put({
        type: customerActions.SET_OBJECTION_PAYMENT_REPORT,
        payload: [],
      });
    }
  } catch (err) {}
};

const getUniqueObjectionReport = function* (data) {
  const { courseid, examDate, section, question_id } = data.payload;
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/unique-objection-report`, {
        params: {
          courseid: courseid,
          examDate: examDate,
          section: section,
          question_id: question_id,
        },
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_UNIQUE_OBJECTION_REPORT,
        payload: result?.data?.result,
      });
    } else {
      yield put({
        type: customerActions.SET_UNIQUE_OBJECTION_REPORT,
        payload: [],
      });
    }
  } catch (err) {}
};

const getPreferenceWiseReport = function* (data) {
  const { courseid, preference } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/customer/preferenceWise-candidate-report`,
        {
          params: {
            courseids: courseid,
            preference: preference,
          },
        }
      )
    );

    if (result?.data?.statusCode === 200) {
      // const dateWiseReportData = result.data.result;
      const preferenceWiseReportData = result.data.result;

      yield put({
        type: customerActions.SET_PREFERENCEWISE_REPORT,
        payload: preferenceWiseReportData,
      });
    }else {yield put({ type: customerActions.SET_PREFERENCEWISE_REPORT, payload: [], }); }
  } catch (err) {
    console.error(err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getAllCoursesPreferenceWiseReport = function* (data) {
  const { preference,courseid } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/customer/all-courses-preferenceWise-candidate-report`,
        {
          params: {
            preference: preference,
            courseid: courseid,
          },
        }
      )
    );

    if (result?.data?.statusCode === 200) {
      const preferenceWiseReportData = result.data.result;

      yield put({
        type: customerActions.SET_PREFERENCEWISE_REPORT,
        payload: preferenceWiseReportData,
      });
    } else {
      yield put({
        type: customerActions.SET_PREFERENCEWISE_REPORT,
        payload: [],
      });
    }
  } catch (err) {
    console.error(err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getPreferenceWiseReportForAllCourses = function* (data) {
  const { preference } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/customer/preferenceWise-candidate-report-for-all-courses`,
        {
          params: {
            preference: preference,
          },
        }
      )
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES,
        payload: result?.data?.result,
      });
    } else {
      yield put({
        type: customerActions.SET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES,
        payload: [],
      });
    }
  } catch (err) {
    console.error(err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const uploadReconciliationFile = function* (data) {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const { payload } = data;
    const result = yield call(() =>
      axios.post(`${API_URL}/upload-airpay-report`, payload, {
        headers: {
          "x-api-key": "Rahul@1992",
        },
      })
    );

    if (result?.status === 202 && result?.data?.job_id) {
      // The backend processes the CSV in the background; poll until it finishes.
      // A status call can time out while the backend is saving a batch, so only
      // give up after several failures in a row (or when the job no longer exists).
      const MAX_STATUS_FAILURES = 10;
      let job = { status: "processing" };
      let failures = 0;
      do {
        yield delay(3000);
        try {
          const statusResult = yield call(() =>
            axios.get(`${API_URL}/upload-airpay-report/status/${result.data.job_id}`, {
              headers: {
                "x-api-key": "Rahul@1992",
              },
            })
          );
          job = statusResult?.data;
          failures = 0;
        } catch (statusErr) {
          failures++;
          console.error("Upload status check failed:", statusErr);
          if (statusErr?.response?.status === 404 || failures >= MAX_STATUS_FAILURES) {
            job = {
              status: "failed",
              error: "Could not get the upload status. The file may still be processing, check again later.",
            };
          }
        }
      } while (job?.status === "processing");

      yield put({
        type: commonActions.SET_ALERT,
        payload:
          job?.status === "completed"
            ? {
                status: "success",
                show: true,
                message: `File uploaded successfully (${job.records_processed} records processed)`,
              }
            : {
                status: "failed",
                show: true,
                message: job?.error || "Failed to process file",
              },
      });
    } else if (result?.status === 200) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: true,
          message: "File uploaded successfully",
        },
      });
    } else {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Failed to upload file",
        },
      });
    }
    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    console.error("Error uploading reconciliation file:", err);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: err?.response?.data?.message || "Failed to upload file",
      },
    });
    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getReconciliationReport = function* (data) {
  const {
    fromDate,
    toDate,
    courseid,
    reconciliationStatus,
    portalStatus,
    airpayStatus,
    page = 1,
    limit = 50,
  } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/reconciliation-report`, {
        params: {
          fromDate,
          toDate,
          courseid,
          reconciliationStatus,
          portalStatus,
          airpayStatus,
          page,
          limit,
        },
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: customerActions.SET_RECONCILIATION_REPORT,
        payload: {
          result: result.data.result,
          pagination: result.data.pagination,
          summary: result.data.summary || {},
        },
      });
    } else {
      yield put({
        type: customerActions.SET_RECONCILIATION_REPORT,
        payload: { result: [], pagination: null, summary: {} },
      });
    }
  } catch (err) {
    console.error("Error fetching reconciliation report:", err);
    yield put({
      type: customerActions.SET_RECONCILIATION_REPORT,
      payload: { result: [], pagination: null, summary: {} },
    });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const downloadReconciliationReport = function* (data) {
  const {
    fromDate,
    toDate,
    courseid,
    reconciliationStatus,
    portalStatus,
    airpayStatus,
  } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const response = yield call(() =>
      axios.get(`${API_URL}/backoffice/customer/reconciliation-report`, {
        params: {
          fromDate,
          toDate,
          courseid,
          reconciliationStatus,
          portalStatus,
          airpayStatus,
          isdownload: 1,
        },
        responseType: "blob",
      })
    );
    const csvText = yield call(() => response.data.text());
    const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `reconciliation_report-${new Date().toISOString().split("T")[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error downloading reconciliation report:", err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const overrideReconciliationStatus = function* (data) {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/customer/reconciliation-override`, data.payload)
    );
    if (result?.data?.statusCode === 200) {
      yield put({ type: customerActions.OVERRIDE_RECONCILIATION_SUCCESS });
      // Re-fetch the report with the same params
      if (data.onSuccess) data.onSuccess();
    }
  } catch (err) {
    console.error("Error overriding reconciliation status:", err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};


// The sync runs in the background on the server (~10 min), so start it and
// poll its status instead of holding one request open past proxy timeouts.
const SYNC_POLL_INTERVAL_MS = 15000;
const SYNC_POLL_MAX_MS = 60 * 60 * 1000;

const getLatestDbDump = function* (data) {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const { fromDate, toDate } = data.payload;
    try {
      yield call(() =>
        axios.get(`${API_URL}/backoffice/customer/reconciliation-sync`, {
          params: {
            fromDate,
            toDate,
          },
        })
      );
    } catch (err) {
      // 409: a sync is already running — wait for that one to finish.
      if (err?.response?.status !== 409) throw err;
    }

    let syncStatus = "RUNNING";
    let pollErrors = 0;
    for (
      let waited = 0;
      syncStatus === "RUNNING" && waited < SYNC_POLL_MAX_MS;
      waited += SYNC_POLL_INTERVAL_MS
    ) {
      yield delay(SYNC_POLL_INTERVAL_MS);
      try {
        const statusResult = yield call(() =>
          axios.get(`${API_URL}/backoffice/customer/reconciliation-sync-status`)
        );
        syncStatus = statusResult?.data?.data?.status;
        pollErrors = 0;
      } catch (err) {
        // tolerate brief network blips while the sync keeps running
        if (++pollErrors >= 3) throw err;
      }
    }

    if (syncStatus === "SUCCESS") {
       yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: true,
          message: "Latest DB dump fetched successfully",
        },
      });
    }else {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Failed to fetch latest DB dump",
        },
      });
    }
     yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
     console.error("Error fetching latest DB dump:", err);

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Something went wrong while syncing DB",
      },
    });
   } finally {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  }
};

const getVBSAReport = function* (data) {
  const { courseid,preference } = data.payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/customer/vbsa-report`,
        {
          params: {
            courseids: courseid,
            preference: preference,
          },
        }
      )
    );
    if (result?.data?.statusCode === 200) {
      const vbsaReportData = result.data.result;
      yield put({
        type: customerActions.SET_VBSA_REPORT,
        payload: vbsaReportData,
      });
    }else {
      yield put({
        type: customerActions.SET_VBSA_REPORT,
        payload: [],
      });
    }
  } catch (err) {
    console.error("Error fetching VBSA report:", err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

export default customerSagas;
